import React from "react";
import PropTypes from "prop-types";
import LoaderSVG from "../../assets/icons/loader.svg";
import "./Loader.scss";

const Loader = ({ style }) => (
	<div style={style} className="loader">
		<LoaderSVG className="loader__spinner" />
	</div>
);

Loader.propTypes = {
	style: PropTypes.objectOf(PropTypes.object),
};

Loader.defaultProps = {
	style: {},
};

export default Loader;
